/**
 * Shipway API client
 *
 * Wraps all backend endpoints related to Shipway tracking:
 *   GET  /api/shipments              – paginated list
 *   GET  /api/shipments/analytics    – analytics summary
 *
 * The webhook is called directly by Shipway (no frontend call needed).
 *
 * @module api/crm/shipwayApi
 */

import { get } from '../apiClient';

const BASE = '/shipments';

/**
 * Fetch paginated shipment list.
 *
 * @param {{ page?: number, limit?: number, status?: string, courier?: string, search?: string }} params
 * @returns {Promise<{ data: Array, pagination: { page, limit, total, pages } }>}
 */
export const getShipments = (params = {}) => {
    const query = new URLSearchParams();
    if (params.page) query.set('page', params.page);
    if (params.limit) query.set('limit', params.limit);
    if (params.status) query.set('status', params.status);
    if (params.courier) query.set('courier', params.courier);
    if (params.search) query.set('search', params.search);

    const qs = query.toString();
    return get(`${BASE}/list${qs ? `?${qs}` : ''}`);
};

/**
 * Fetch courier analytics summary.
 *
 * @param {{ startDate?: string, endDate?: string }} params
 * @returns {Promise<{ totalShipments, delivered, inTransit, rto, successRate, avgDeliveryTime, courierPerformance[] }>}
 */
export const getShipmentAnalytics = (params = {}) => {
    const query = new URLSearchParams();
    if (params.startDate) query.set('startDate', params.startDate);
    if (params.endDate) query.set('endDate', params.endDate);

    const qs = query.toString();
    return get(`${BASE}/analytics${qs ? `?${qs}` : ''}`);
};
